import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CardModule } from 'primeng/card';

import { ContentComponentType } from '@ppg/core/enums';
import { CardItem } from '@ppg/core/models';

import { AssetDocumentCardComponent } from './cards/asset-document-card/asset-document-card.component';
import { AssetUrlCardComponent } from './cards/asset-url-card/asset-url-card.component';
import { AssetYoutubeVideoComponent } from './cards/asset-youtube-video-card/asset-youtube-video-card.component';
import { GeneralCardComponent } from './cards/general-card/general-card.component';
import { PageCardComponent } from './cards/page-card/page-card.component';

@Component({
  selector: 'ppg-general-presentation-component',
  standalone: true,
  imports: [
    CardModule,
    GeneralCardComponent,
    AssetUrlCardComponent,
    PageCardComponent,
    AssetDocumentCardComponent,
    AssetYoutubeVideoComponent,
  ],
  templateUrl: './general-presentation.component.html',
  styleUrl: '../../container-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralPresentationComponent {
  readonly cards = input.required<CardItem[]>();

  readonly ContentComponentType = ContentComponentType;
}
